// বিষয় অনুযায়ী কার্ডের হালকা রঙ (hue)। ব্র্যান্ডের টিল (174) ডিফল্ট; অ্যাডমিন নতুন বিষয় যোগ করলে
// তার মান থেকে স্থির একটা hue বের হয়, যাতে একই বিষয় সবসময় একই রঙে দেখায়।
const SUBJECT_HUES = {
  bangla: 350,
  english: 222,
  math: 30,
  science: 134,
  "religion-arabic": 165,
  "social-science": 285,
  ict: 194,
  other: 255,
};

export function toneHue(subject) {
  if (!subject) return 174;
  if (subject in SUBJECT_HUES) return SUBJECT_HUES[subject];
  let h = 7;
  for (const ch of String(subject)) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}
